var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
// @ts-nocheck
import React from 'react';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import { mergeClasses } from '@material-ui/styles';
import theme from '@dev-togetherprice/theme';
import SidebarAdminWrapper from './components/SidebarAdminWrapper';
import SidebarNavList from './components/SidebarNavList';
export const useStyles = makeStyles(() => ({
    sidebar: {
        zIndex: 10,
        transition: '.4s',
        paddingTop: theme.spacing(7),
        backgroundColor: 'white',
        height: '100%',
        width: '325px',
        position: 'fixed',
        top: '90px',
        left: 0,
        overflowX: 'hidden',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    sidebarClosed: {
        width: '80px !important',
    },
}));
const Sidebar = ({ showSidebar, activeTab, classes = {}, navigateToUrl, isPublic, }) => {
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const baseClasses = useStyles({ showSidebar });
    const { fullName, adminAvatar, sidebar } = classes, sidebarNavListClasses = __rest(classes, ["fullName", "adminAvatar", "sidebar"]);
    const adminWrapperClasses = {
        fullName,
        adminAvatar,
    };
    const allClasses = mergeClasses({
        baseClasses,
        newClasses: { sidebar },
        Component: Sidebar,
    });
    if (!matches) {
        return null;
    }
    return (React.createElement("div", { className: clsx({
            [allClasses.sidebar]: true,
            [allClasses.sidebarClosed]: !showSidebar,
        }) },
        React.createElement(SidebarAdminWrapper, { isPublic: isPublic, navigateToUrl: navigateToUrl, showSidebar: showSidebar, classes: adminWrapperClasses }),
        React.createElement(SidebarNavList, { activeTab: activeTab, collapsed: !showSidebar, navigateToUrl: navigateToUrl, classes: sidebarNavListClasses })));
};
export default Sidebar;
